export const SET_REAL_ESTATE_DATA = 'SET_REAL_ESTATE_DATA';